export const ConsentTypes = [
    {
        type: "CreditsRemoved",
        modalType: "consent",
        start: "2024-04-16",
        end: "2024-05-31",
    },
    {
        type: "ChangelogPlaybook",
        modalType: "custom",
        start: "2024-05-23",
        end: "2024-06-31",
    }
];